type TeamLike = { ID?: number; deleted?: number | boolean | null } | null | undefined;

export const isTeamDeleted = (team: TeamLike): boolean => !!Number(team?.deleted);

export const isTeamActive = (team: TeamLike): boolean => !isTeamDeleted(team);

export const isActiveTeamWarehouse = (
    warehouse: { teamId?: number; teamDeleted?: number | boolean | null } | null | undefined,
    teams?: TeamLike[] | null,
): boolean => {
    if (!warehouse?.teamId) return true;
    if (warehouse.teamDeleted !== undefined && warehouse.teamDeleted !== null) {
        return !Number(warehouse.teamDeleted);
    }
    const team = teams?.find((t) => t?.ID === warehouse.teamId);
    return isTeamActive(team);
};
